import { Outlet } from "react-router-dom";

import { OperationalModulePickerProvider } from "@shared/contexts";
import { Header } from "../organisms/Header";
import { Sidebar } from "../organisms/Sidebar";
import { MainTemplate } from "../templates/MainTemplate";

const MainPageContent = ({
  hideSidebar = false,
}: {
  hideSidebar?: boolean;
}) => {
  return (
    <MainTemplate
      Header={<Header />}
      SideBar={hideSidebar ? <></> : <Sidebar />}
    >
      <Outlet />
    </MainTemplate>
  );
};

export const MainPage = ({
  hideSidebar = false,
}: {
  hideSidebar?: boolean;
}) => {
  return (
    <OperationalModulePickerProvider>
      <MainPageContent hideSidebar={hideSidebar} />
    </OperationalModulePickerProvider>
  );
};
